import { ClientFrontlineConfig, OpportunitySfId } from 'app/types/types'
import { t } from 'i18next'
import { getSFData } from 'app/services/client/client-api'
import { checkIfContractInactive } from 'app/app/common/common-utils'
import * as R from 'ramda'
import { updateOfferAsync } from './update-offer-async'
import { updateOfferSalesforceData } from 'app/app/(client)/nemo/offer/salesforce-sync'
import { setCurrentAccount } from '../customers/current-account-slice'
import { confirmResetDialogProps, errorAlert, waitDialog } from '../notification/modal-state'
import { showAlert, hideAlert } from '../notification/alert-slice'
import { compileOfferingQuestions } from 'app/app/(client)/nemo/offering/questions'
import { validateOfferUpdate } from './validate-offer-async'
import { wrapCreateAsyncThunk } from 'app/app/(client)/utils/async-handler'
import { Translations } from 'app/app/(client)/utils/client-constants'

export const resetOpportunity = wrapCreateAsyncThunk<void, OpportunitySfId>(
  'currentOffer/resetAndSyncOpportunity',
  async (opportunityId: OpportunitySfId, thunkAPI) => {
    const { dispatch, getState } = thunkAPI
    dispatch(showAlert({ ...waitDialog(Translations.sfreviewWait) }))
    const opportunityCustomer = await getSFData(opportunityId)

    let hasInactiveContract = false
    const inactiveConractswithID: string[] = []
    opportunityCustomer.opportunities?.forEach(opportunity => {
      if (opportunity.id === opportunityId) {
        hasInactiveContract = checkIfContractInactive(opportunity) || false
        if (hasInactiveContract) {
          opportunity.contracts?.forEach(contract => {
            if (contract.inactiveContract) {
              inactiveConractswithID.push(contract.name)
            }
          })
        }
      }
    })

    if (hasInactiveContract) {
      dispatch(
        showAlert({
          ...errorAlert(
            dispatch,
            t('review.initial.inactiveContractDialog', { inactiveContracts: inactiveConractswithID.join(', #') }),
            'Inactive contract encountered',
            undefined,
            undefined,
            'warning'
          )
        })
      )
    } else {
      const sync = () => {
        dispatch(hideAlert())
        setTimeout(() => {
          const customer = R.dissoc('opportunities', opportunityCustomer)
          const opportunity = opportunityCustomer.opportunities[0]
          opportunity !== undefined
            ? dispatch(
                validateOfferUpdate({
                  onSuccess: () => {
                    const { data: customerAccountData } = getState().customers
                    const currentaccount = customerAccountData
                      ? customerAccountData.customers?.find(customerAccount => customerAccount.id === customer.id)
                      : undefined
                    const relatedOpportunityBeforeSync =
                      currentaccount && currentaccount.opportunities
                        ? currentaccount.opportunities.filter(
                            opp =>
                              opp.opportunityNumber !== opportunity?.opportunityNumber &&
                              opp.businessType === opportunity?.businessType
                          )
                        : []
                    relatedOpportunityBeforeSync.forEach(opportunityEntity =>
                      opportunityCustomer.opportunities.push(opportunityEntity)
                    )
                    const configData = getState().configdata.data
                    if (configData && configData.frontLineConfig) {
                      const updatedFlConfigData: ClientFrontlineConfig = {
                        ...configData.frontLineConfig,
                        offeringQuestions: compileOfferingQuestions(configData.frontLineConfig.offerSelections)
                      }
                      dispatch(updateOfferAsync(updateOfferSalesforceData(opportunity, customer, updatedFlConfigData)))
                    }
                    dispatch(setCurrentAccount(opportunityCustomer))
                  }
                })
              )
            : dispatch(
                showAlert({
                  ...errorAlert(dispatch, 'Contract not found for the Opportunity. Check in CRM', 'No contract found')
                })
              )
        }, 100)
      }
      dispatch(showAlert(confirmResetDialogProps(dispatch, sync)))
    }
  }
)
